export const CHAT_MESSAGE_SEGMENT_MAX_LENGTH = 700;
export const CHAT_MESSAGE_MAX_SEGMENTS = 6;
export const CHAT_MESSAGE_TEXT_MAX_LENGTH = 4100;

export function limitChatMessageText(text = "") {
  const value = String(text);
  if (value.length <= CHAT_MESSAGE_TEXT_MAX_LENGTH) {
    return value;
  }
  return value.slice(0, CHAT_MESSAGE_TEXT_MAX_LENGTH);
}

export function splitChatMessageText(text = "") {
  const trimmedText = String(text).trim();
  if (!trimmedText) {
    return [];
  }

  const segments = [];
  let start = 0;

  while (start < trimmedText.length) {
    if (segments.length >= CHAT_MESSAGE_MAX_SEGMENTS) {
      throw new Error("CHAT_MESSAGE_PAYLOAD_TOO_LONG");
    }

    const candidateEnd = Math.min(
      start + CHAT_MESSAGE_SEGMENT_MAX_LENGTH,
      trimmedText.length,
    );

    if (candidateEnd === trimmedText.length) {
      appendSegment(trimmedText.slice(start, candidateEnd), segments);
      break;
    }

    const remainingSegmentsAfterCurrent =
      CHAT_MESSAGE_MAX_SEGMENTS - segments.length - 1;
    const minimumSegmentEnd = Math.max(
      start,
      trimmedText.length -
        remainingSegmentsAfterCurrent * CHAT_MESSAGE_SEGMENT_MAX_LENGTH,
    );

    if (minimumSegmentEnd > candidateEnd) {
      throw new Error("CHAT_MESSAGE_PAYLOAD_TOO_LONG");
    }

    const splitIndex = findLastWhitespaceIndex(
      trimmedText,
      minimumSegmentEnd,
      candidateEnd,
    );
    const segmentEnd = splitIndex ?? candidateEnd;
    appendSegment(trimmedText.slice(start, segmentEnd), segments);

    start = segmentEnd;
    while (start < trimmedText.length && /\s/.test(trimmedText[start])) {
      start += 1;
    }
  }

  if (segments.length > CHAT_MESSAGE_MAX_SEGMENTS) {
    throw new Error("CHAT_MESSAGE_PAYLOAD_TOO_LONG");
  }

  return segments;
}

function appendSegment(segment, segments) {
  const trimmedSegment = segment.trim();
  if (trimmedSegment) {
    segments.push(trimmedSegment);
  }
}

function findLastWhitespaceIndex(text, start, end) {
  for (let index = end - 1; index >= start; index -= 1) {
    if (/\s/.test(text[index])) {
      return index;
    }
  }
  return null;
}

export function getTimestampForChatMessageSegment(baseTimestamp, index) {
  const base =
    baseTimestamp instanceof Date
      ? baseTimestamp
      : new Date(baseTimestamp || Date.now());
  return new Date(base.getTime() + index);
}
